import { useBrowserIdleCheck } from '@dmp/hooks';
import { getTenantConfig } from '@dmp/stores';
import {
  checkAndRefreshToken,
  getIsLoggedIn,
  getShouldRefreshToken,
  isTokenExpired,
  redirectToLandingPageAndClearCache,
  reLogin,
} from '@dmp/utils';

let timer: number | null;

const stopTimer = () => {
  if (timer) {
    window.clearInterval(timer);
  }
  timer = null;
};

const resetPage = () => {
  const enforce_login = getTenantConfig()?.enforce_login;
  if (enforce_login) {
    reLogin();
  } else {
    redirectToLandingPageAndClearCache();
  }
};

const onIdle = () => {
  const checkTokenAndLogout = () => {
    const shouldRefreshToken = getShouldRefreshToken();
    if (getIsLoggedIn() && isTokenExpired() && !shouldRefreshToken) {
      resetPage();

      stopTimer();
      return;
    }

    if (shouldRefreshToken) {
      checkAndRefreshToken();
    }
  };

  checkTokenAndLogout();
  // check the token every 30s during idle.
  timer = window.setInterval(() => {
    checkTokenAndLogout();
  }, 1000 * 30);
};

const onActive = () => {
  stopTimer();
};

export const useIdleCheckTokenResetPage = () => {
  useBrowserIdleCheck({
    onIdle,
    onActive,
  });
};
